import React from 'react'
import { Link } from 'react-router-dom'
import wad from '../../../../assets/img/saas_mn.webp'
import './Wadhead.css'
import ContactForm from '../../Contact/ContactForm'

function Wadhead() {
  return (
    <section className='hmslder-sec serhead-sec'>
        <div className='breadcrumbs'>
            <div className='container'>
             <ul>
               <li><Link to='/'>Home</Link></li> 
               <li><Link to='/Service'>Services</Link></li>  
               <li>SaaS Development</li>   
             </ul> 
             </div> 
        </div>
        <div className='container'>
           <div className='hmslder-txt'>
              <h2>From idea to multiplatform SaaS that users love - Build secure, scalable and maintainable <span>SaaS products with a partner</span> who understands product-market fit</h2>
              <p>360 Bytes helps entrepreneurs and enterprises build SaaS products that scale from initial MVP to enterprise deployments. We focus on delivering rapid validation, repeatable architecture, and operational processes that keep your service resilient and cost effective.
              </p>
            </div> 
            <ContactForm thankYouSource="saas-development" />
           {/* <div className='hmslder-img'>
            <img src={wad} alt='SaaS Development' width={1200} height={800} loading="lazy" />
            </div>   */}
        </div>
    </section>
  )
}

export default Wadhead
